import { render, staticRenderFns } from "./eventEditComponent.vue?vue&type=template&id=1ec00b6f&"
import script from "./eventEditComponent.vue?vue&type=script&lang=ts&"
export * from "./eventEditComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports